<template>
  <modal class="q-modal addstaticmac" name="add-address-modal" :class="ifTop"
       transition="nice-modal-fade"
       :width="600"
       :min-width="600"
       :delay="100"
       :draggable="'.modal-header'"
       :clickToClose="false"
       :adaptive="true"
       @opened="Opened"
       classes='q-v--modal'>
    <div class="modal-content">
      <div class="modal-header">
        {{modalTitle}}
      </div>
      <div class="icon-btn_close modal-close" @click="onClose()"></div>
      <scrollbar ref="scrollbar" class="scrollbar-body">
        <div class="modal-body">
          <div class="modal-container">
            <div class="form">
              <div class="formRow dt">
                <div class="dt-r">
                  <span class="title dt-c">{{$t('mactable.vlanId')}}</span>
                  <span class="forminput dt-c" v-if="isAdd">
                    <input name="ID" class="form-control vlanIdInput" type="text" :class="{'error': errors.has('ID') || IDnoExist}" v-model="vlanId" v-validate="'required|numeric|min_value:1|max_value:4000'" @keyup="onBlur" @change="onBlur" @keypress="onlyNumber" min="1">
                  </span>
                  <span class="forminput" v-else>{{vlanId}}</span>
                </div>
                <div class="dt-r">
                  <div class="dt-c"></div>
                  <div class="errorMessage dt-c" v-show="errors.has('ID') || IDnoExist">{{ (IDnoExist) ? $t('errorMessage.vlanNumNoExists') : setErrorMessage(errors.first('ID')) }}</div>
                </div>
              </div>
              <div class="formRow dt">
                <div class="dt-r">
                  <span class="title dt-c">{{$t('mactable.macAddress')}}</span>
                  <span class="forminput dt-c" v-if="isAdd">
                    <input name="macaddress" class="form-control addressInput" type="text" placeholder="FF:FF:FF:FF:FF:FF" :class="{'error': errors.has('macaddress')}" v-model="macaddress" v-validate="'required|macaddress'" @keyup="onBlur" @change="onBlur">
                  </span>
                  <span class="forminput" v-else>{{macaddress}}</span>
                </div>
                <div class="dt-r">
                  <div class="dt-c"></div>
                  <div class="errorMessage dt-c" v-show="errors.has('macaddress')">{{ setErrorMessage(errors.first('macaddress')) }}</div>
                </div>
              </div>
              <div class="formRow">
                <div class="port-members">{{$t('vlan.vlanCong')}}</div>
                <div class="forminput">
                  <div class="port-select">
                    <table>
                      <tr class="table-header">
                        <td style="width:24%;">{{$t('overview.portNo')}}</td>
                        <td :style="{ width: 76/(portNumber) + '%' }" v-for="num in portNumber" :key="num">{{num}}</td>
                      </tr>
                      <tr class="table-body">
                        <td class="table-body-content" style="width:24%;">{{$t('selected')}}</td>
                        <td class="table-body-content" :style="{ width: 76/(portNumber) + '%' }" v-for="num in portNumber" :key="num" :title="getTips(num)">
                          <radio class="formlabel fontB subitem" :checked="isItemChecked(num)" @click.native="onSelection(num)" :disabled="getDisabled(num)" :id="'radio-' + (num)"></radio>
                        </td>
                      </tr>
                    </table>
                    <table>
                      <tr class="table-header">
                        <td style="width:24%;">{{$t('overview.portNo')}}</td>
                        <td :style="{ width: 76/lagGroupMap.size + '%' }" v-for="num in lagGroupMap.size" :key="num + lagStartNum">{{$t('lag.groupName') + ' ' + num}}</td>
                      </tr>
                      <tr class="table-body">
                        <td class="table-body-content" style="width:24%;">{{$t('selected')}}</td>
                        <td class="table-body-content" :style="{ width: 76/lagGroupMap.size + '%' }" v-for="num in lagGroupMap.size" :key="num + lagStartNum">
                          <radio class="formlabel fontB subitem" :checked="isItemChecked(num + lagStartNum)" @click.native="onSelection(num + lagStartNum)" :id="'radio-' + (num + lagStartNum)"></radio>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </scrollbar>
      <div class="modal-footer">
        <div class="footer-left">
        </div>
        <div class="footer-right">
          <button class="q-button blue-btn-full" @click="onSaveClick()" :disabled="!saveBtn" :title="$t('save')">{{$t('save')}}</button>
          <button class="q-button" @click="onClose()" :title="$t('cancel')">{{$t('cancel')}}</button>
        </div>
      </div>
      <popup-confirm :selHeight="160" name="mac-warn-modal" :dialog-header="modalContent" icon="w" :onlyOk=true />
    </div>
  </modal>
</template>

<script>
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex'
import Radio from './module/Radio'
export default {
  name: 'StaticMac',
  props: {
    selectObj: Object,
    modalTitle: String,
    onChange: Function
  },
  components: {
    Radio
  },
  data () {
    return {
      modalname: 'add-address-modal',
      showModal: true,
      vlanId: null,
      macaddress: '',
      cellSelect: 0,
      saveBtn: false,
      errorMessage: '',
      isIDValidation: true,
      isAddressValidation: true,
      vlanIdx: null,
      IDnoExist: false,
      isAdd: false,
      vlanPortList: [],
      modalContent: ''
    }
  },
  watch: {
    selectObj: function (value) {
      this.setInitial()
      if (this.$compareObj(value, {})) {
        this.isAdd = true
      } else {
        this.isAdd = false
        this.vlanId = value.key[0]
        this.macaddress = value.key[1]
        this.cellSelect = Number(value.val.Port)
        this.getSelectVlan()
      }
    }
  },
  created: async function () {
    let me = this
    this.$validator.extend('macaddress', {
      getMessage (field, val) {
        return me.$t('errorMessage.format')
      },
      validate (value, field) {
        var temp = /^([0-9A-Fa-f]{2}[:]){5}([0-9A-Fa-f]{2})$/
        if (!temp.test(value)) {
          return false
        }
        return true
      }
    })
    this.getVlanIdx()
      .then((result) => {
        if (result.data.error_code === 200) {
          this.vlanIdx = result.data.result.idx
        }
      })
  },
  methods: {
    ...mapMutations([
      'openModal',
      'closeModal'
    ]),
    Opened (event) {
      const modal = document.querySelector('.v--modal-box.q-v--modal')
      let height = document.body.clientHeight
      let temph = (height > 405) ? 405 : height - 90
      if (modal) {
        modal.style.height = temph + 'px'
        modal.style.top = 'calc(50% - ' + (temph / 2) + 'px'
      }
    },
    setInitial: function () {
      this.vlanId = null
      this.saveBtn = false
      this.cellSelect = 0
      this.errorMessage = ''
      this.macaddress = ''
      this.isIDValidation = true
      this.isAddressValidation = true
      this.IDnoExist = false
    },
    getSelectData: function (selectItem) {
      this.isBtnValidation = true
      this.cellSelect = this.getPort(selectItem)
    },
    getPort: function (portList) {
      if (portList !== null) {
        let data = portList.val.PortList
        let newPortList = []
        for (const key in data) {
          if (data.hasOwnProperty(key)) {
            const element = data[key]
            let portNumber = element
            portNumber = parseInt(portNumber)
            if (portNumber < 17) {
              newPortList.push(portNumber)
            }
          }
        }
        return newPortList
      }
    },
    getSelectVlan: async function () {
      if (this.vlanId) {
        this.vlanPortList = []
        await this.getVlanById(this.vlanId)
          .then((result) => {
            if (result.data && result.data.error_code === 200) {
              result.data.result[0].val.forEach(element => {
                this.vlanPortList.push(element.Port)
              })
            }
          }).catch((erroe) => {
          })
      }
    },
    isItemChecked: function (item) {
      return (this.cellSelect === item)
    },
    onSelection: function (item) {
      this.cellSelect = item
      this.checkValidation()
    },
    onOpen () {
      this.openModal(this.modalname)
      this.$modal.show(this.modalname)
    },
    onClose () {
      this.setInitial()
      this.closeModal(this.modalname)
      this.$modal.hide(this.modalname)
    },
    onBlur: function (event) {
      this.checkValidation(event.target.name)
    },
    checkCellValidation: function () {
      if (this.cellSelect !== 0) {
        this.saveBtn = true
      } else {
        this.saveBtn = false
      }
    },
    checkPortValid: function () {
      if (this.vlanPortList.indexOf('' + this.cellSelect) > -1) {
        return true
      } else {
        return false
      }
    },
    checkMacAddressValidate: function () {
      let tempArray = this.macaddress.split('.')
      if (!((parseInt(tempArray[0], 16)) % 2 === 0)) {
        return false
      } else {
        return true
      }
    },
    onAddSave: function (data) {
      this.addStaticMac(data).then((res) => {
        this.$log.debug(res)
        this.closeModal(this.modalname)
        this.$modal.hide(this.modalname)
        this.onChange()
        this.setInitial()
      })
        .catch(error => {
          this.$log.error(error)
          if (error.response.data.error_code === 409) {
            this.modalContent = this.$t('mactable.duplicate')
            this.$modal.show('mac-warn-modal')
            this.openModal('mac-warn-modal')
          } else if (error.response.data.error_code === 406) {
            this.modalContent = this.$t('mactable.samePortDuplicate')
            this.$modal.show('mac-warn-modal')
            this.openModal('mac-warn-modal')
          }
        })
    },
    onEditSave: function (data) {
      this.setStaticMac(data).then((res) => {
        this.$log.debug(res)
        this.closeModal(this.modalname)
        this.$modal.hide(this.modalname)
        this.onChange()
        this.setInitial()
      }).catch(error => {
        this.$log.error(error)
      })
    },
    onSaveClick: async function () {
      var data = {
        idx: [
          this.vlanId,
          this.macaddress
        ],
        data: {
          Port: '' + this.cellSelect
        }
      }
      if (this.macaddress === '00:00:00:00:00:00') {
        this.modalContent = this.$t('mactable.invalidMacAddress')
        this.$modal.show('mac-warn-modal')
        this.openModal('mac-warn-modal')
        return
      }
      await this.getSelectVlan()
      if (this.checkMacAddressValidate()) {
        if (this.checkPortValid()) {
          if (this.isAdd) {
            this.onAddSave(data)
          } else {
            this.onEditSave(data)
          }
        } else {
          this.modalContent = this.$t('mactable.portInvalid')
          this.$modal.show('mac-warn-modal')
          this.openModal('mac-warn-modal')
        }
      } else {
        this.modalContent = this.$t('mactable.invaild')
        this.$modal.show('mac-warn-modal')
        this.openModal('mac-warn-modal')
      }
    },
    checkValidation: function () {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          if (!this.$validator.errors.has('ID') && !this.vlanIdx.includes(this.vlanId)) {
            this.IDnoExist = !result
          } else {
            this.IDnoExist = result
          }
          this.saveBtn = result
        } else {
          if (!this.vlanIdx.includes(this.vlanId)) {
            this.IDnoExist = result
            this.saveBtn = !result
          } else {
            this.IDnoExist = !result
            this.checkCellValidation()
          }
        }
      })
    },
    setErrorMessage: function (data) {
      let message = ''
      if (data) {
        if (data.indexOf('required') > -1) {
          message = this.$t('errorMessage.isReguired')
        } else if (data.indexOf('ID') > -1) {
          message = this.$t('errorMessage.staticMacVlanIdRange')
        } else {
          message = data
        }
      }
      return message
    },
    onlyNumber ($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which)
      let isFunctionKey = false
      switch (keyCode) {
        case 8:
          isFunctionKey = true
          break
      }
      if ((keyCode < 48 || keyCode > 57) && !isFunctionKey) { // 46 is dot
        $event.preventDefault()
      }
    },
    getDisabled: function (port) {
      if (this.portMap.get(port)) {
        return true
      } else {
        return false
      }
    },
    getTips: function (key) {
      let num = Number(key)
      let tips = ''
      if (this.getDisabled(num)) {
        tips = this.$t('lag.alreadyJoin')
      }
      return tips
    },
    ...mapActions([
      'addStaticMac', 'getVlanIdx', 'getVlanById', 'setStaticMac'
    ])
  },
  computed: {
    ...mapState({
      portNumber: state => state.module.portNum,
      portMap: state => state.module.portMap,
      lagStartNum: state => state.module.lagStartNum,
      lagGroupMap: state => state.module.lagGroupMap
    }),
    ...mapGetters(['getTopModalName']),
    ifTop () {
      this.$log.debug('this.getTopModalName' + this.getTopModalName)

      if (this.getTopModalName !== this.modalname) {
        return 'noTopModal'
      } else {
        return 'none'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/variables.scss';

@import '../assets/scss/modal.scss';

.addstaticmac {
  .modal-container {
    .formRow {
      margin-bottom: 10px;
      .title {
        width: 100px;
      }
      .forminput.port-table {
        width: 100%;
        display: block;
      }
      .forminput {
        .port-select {
          margin-top: 10px;
          >table {
            margin-top: 8px;
            width: 100%;
            text-align: center;
            td {
              border: 1px solid #F1F1F1;
            }
            .table-header {
              background: #F2F3F8;
              height: 28px;
              text-align: center;
            }
            .table-body {
              height: 38px;
            }
          }
        }
      }
      .form-control {
        width: 150px;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/StaticMac.vue